import React from "react";

type Props = {
  /**
   * progress complete% range 0 - 100
   */
  percent: number;
};

function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians),
  };
}

function describeArc(x, y, radius, startAngle, endAngle) {
  const start = polarToCartesian(x, y, radius, endAngle);
  const end = polarToCartesian(x, y, radius, startAngle);

  const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

  const d = [
    "M",
    start.x,
    start.y,
    "A",
    radius,
    radius,
    0,
    largeArcFlag,
    0,
    end.x,
    end.y,
  ].join(" ");

  return d;
}

const ProgressIndicator = ({ percent }: Props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="8.4"
      stroke="#ADCCFF"
      strokeWidth="2.5"
      fill="none"
    />
    <path
      d={describeArc(12, 12, 8.4, 0, (percent / 100) * 360)}
      stroke="#185888"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);

export default ProgressIndicator;
